module.exports = {
  //交互反馈
  request: {
    201: "Parameter error",
    202: "Account number cannot be empty",
    203: "Password cannot be empty",
    204: "Account error",
    205: "Password error",
    206: "Information error, please contact the administrator",
    207: "Currency does not exist",
    300: "request was aborted",
    208: "Purchase quantity out of range",
    209: "Inconsistent passwords",
    236: "Account already exists",
    211: "Original password error",
    212: "New password cannot be empty",
    213: "The name cannot be empty",
    214: "Last name cannot be empty",
    215: "Please select a certificate type",
    216: "Certificate number cannot be empty",
    217: "Front ID photo cannot be empty",
    218: "Negative certificate photo cannot be empty",
    219: "Please select nationality",
    220: "Hand held certificate photo cannot be empty",
    221: "Handheld agreement cannot be empty",
    222: "Sorry, your credit is running low",
    223: "Order error, please contact the administrator",
    230: "The selected currency cannot be the same",
    234: "Please use the correct mailbox",
    235: "Incorrect verification code",
    237: "The current account is not registered, please register",
    231: "The selected currency cannot be blank"
  },

  //国家
  country: {
    Usa: "Usa",
    China: "China",
    korea: "korea",
    Japan: "Japan",
    HongKong: "HongKong",
    Taiwan: "Taiwan",
    Russia: "Russia",
    France: "France",
    britain: "britain",
    Germany: "Germany",
    Brazil: "Brazil",
    Italy: "Italy",
    Canada: "Canada",
    Spain: "Spain",
    Malaysia: "Malaysia",
    Singapore: "Singapore",
    Indonesia: "Indonesia",
    Philippines: "Philippines",
    Vietnam: "Vietnam",
    India: "India",
    Bhutan: "Bhutan",
    Finland: "Finland",
    Sweden: "Sweden",
    Norway: "Norway",
    Iceland: "Iceland",
    Denmark: "Denmark",
    zimbabwe: "zimbabwe",
    Netherlands: "Netherlands",
    Thailand: "Thailand",
  },

  //证件
  certificates: {
    passport: "Passport",
    ID: "Identity Card",
    driverLicense: "Driver's license"
  },

  //通用
  currency: {
    loading: "Loading",
    determine: "Determine",
    cancel: "Cancel",
    tips: "Tips",
    psdRule: "The password must be a combination of letters and numbers",
    psdLength: "The password length shall not be less than 6 digits",
    loginPsdLength: "The password length shall not be less than 8 digits",
    actionSuccess: "Operation succeeded",
    success: "success",
    fail: "fail",
    passed: "Under review",
    return: "return"
  },

  // 登陆页
  login: {
    welComeToLogin: 'Welcome to login',
    username: "Account",
    password: "Password",
    submit: "Submit",
    noAccount: "No account",
    register: "Register",
    forgetPassword: "Forget password",
    loginSuccess: "Login succeeded",
    logoutSuccess: "Log out",
    enterAccount: "Please enter the account number",
    enterPsw: "Please input a password",
    rememberPassword: "Remember password"
  },

  //注册页
  register: {
    registeredAccount: "Registered account",
    mailboxRegistration: "Email",
    mailbox: "Email",
    setPassword: "Set password",
    confirmPassword: "Confirm password",
    readAgree: "I have read and agree",
    userAgreement: "User agreement",
    and: "And",
    privacyClause: "Stealth clause",
    existingAccount: "Existing account",
    signIn: 'Login',
    registerSuccess: "login was successful",
    pleaseRead: "Please read the user agreement and privacy terms first",
    inviteCode: "Invitation code",
    verificationCode: "Email verification code"
  },

  //忘记密码
  forgetPassword: {
    code: "Email verification code",
    forgetPassword: "Forget password",
    sendCode: "Send verification code"
  },

  //顶部导航栏
  nav: {
    home: " Home page",
    quotation: "Quotation",
    transaction: "Transaction",
    notice: "Notice",
    securityCenter: "Security Center",
    assets: "My assets",
    recharge: "Recharge",
    withDrawal: "Withdrawal",
    fundTransfer: "Fund transfer",
    orderCenter: "Order center",
    exchange: "exchange",
    logOut: "Logout",
    downloadApp: "Scan code and download app",
    moreClient: "More clients",
    chinese: "Chinese",
    english: "English",
    korean: "Korean",
    japanese: "Japanese",
    traditionalChinese: "Traditional Chinese character",
    continueToExit: "Continue to exit",
  },

  //首页
  home: {
    name: "Coin",
    price: 'Price',
    amount: "24h Change",
    title: "Trade anytime, anywhere",
    desc: "Multiple terminals are perfectly compatible to meet the transaction needs of various scenarios at any time",
    text1: "View real-time market at any time",
    text2: "Easily buy and sell BTC, ETH, XRP, okb and other digital assets",
    text3: "Get the cryptocurrency price change alert you are concerned about",
    text4: "View bitcoin spot, futures and option prices",
    text5: "Compare cryptocurrency prices across exchanges",
    title1: "Global leader",
    title2: "Digital asset service platform",
    desc2: "Safety, stability and reliability",
    createAccount: "Create account",
    text6: "Start your digital currency journey"
  },

  //行情
  quotes: {
    title: "Today's market"
  },

  //安全中心
  securityCenter: {
    identityAuthentication: "Identity authentication",
    desc: "Completing personal authentication helps to protect account security and improve withdrawal limit and transaction authority",
    go: "Go to",
    loginPassword: "Login password",
    desc1: "Used to protect account security",
    edit: "Modify",
    fundPassword: 'Fund password',
    desc2: "To protect the security of funds",
    setUp: "set up",
    changePassword: "Change Password",
    changePasswordAlert: "Withdrawal and OTC transfer are prohibited within 24 hours after modifying the login password",
    originalPassword: "Original password",
    newPassword: "New password",
    confirmPassword: "Confirm new password",
    setFundPassword: "Set asset password",
    resetFundPassword: "Reset asset password",
    confirmFundPassword: "Confirm asset password",
    setSuccessfully: "Set successfully"
  },

  //身份认证
  personalAuthentication: {
    identityAuthentication: "Identity authentication",
    personalIdentityAuthentication: "Personal identity authentication",
    know: "Know",
    primaryCertification: "Primary certification",
    desc: "Increase the currency withdrawal limit, with a 24-hour limit of 200btc",
    advancedCertification: "Advanced certification",
    submitApproval: "Submit for approval",
    agreementDownload: 'Anti money laundering Agreement Download',
    handCertificates: "Please upload photos of your hand-held certificates",
    handCertificates2: "Please upload photos of anti money laundering agreement",
    national: "Nationality",
    surname: "Surname",
    realname: "Name",
    papersType: "Document type",
    papers: "Identification Number",
    papersPositive: "Please upload the front photo of your certificate",
    papersReverse: "Please upload the photo on the back of the certificate",
    pleaseEnter: "Please enter",
    title: "Why do I have to authenticate",
    content: "Real name certification is to comply with current financial regulations or relevant policies. Real name authentication is more helpful to protect your account security and avoid some fraud. We will keep your information strictly confidential",
    title2: "Which countries are not supported for the time being",
    content2: "Real name certification is to comply with current financial regulations or relevant policies. Real name authentication is more helpful to protect your account security and avoid some fraud. We will keep your information strictly confidential",
    verificationCertification: "Please conduct advanced certification first",
    authentication: "Certified now",
    PrimaryAuditPassed: "Primary audit passed",
    level0: "Registered",
    level1: "Primary audit in progress",
    level2: "Primary audit failed",
    level3: "Primary audit passed",
    level4: "Advanced audit in progress",
    level5: "Senior audit failed",
    level6: "Senior audit passed",
  },

  //交易
  transaction: {
    pleaseSelect: "Please select",
    price: "price",
    requiredMargin: "Required margin",
    closingFee: "Closing fee",
    stopSurplus: "Stop surplus",
    default: "default",
    stopLoss: "Stop loss",
    purchase: "purchase",
    currentPosition: "Current position",
    historicalContract: "Historical contract",
    order: "Order number",
    creationTime: "Creation time",
    transactionType: "Transaction Type",
    buyUp: "Buy Long",
    buyFall: "Buy Short",
    num: "Quantity",
    bond: "Margin",
    serviceCharge: "Handling fee",
    ClosingProfitLoss: "Closing profit and loss",
    netProfitLoss: "Net profit and loss",
    orderStatus: "Order Status",
    operation: "Operate",
    compulsoryLiquidation: "Forced liquidation",
    forceClosing: "Are you sure to liquidate the position?",
    pleaseLogin: "You are not logged in yet, please log in first!",
    buyCurrentPrice: "The current currency price is 0",
    charged: "Closing time",
    buildingTime: "Opening time",
    buildingPrice: "Opening price",
    currencyPriceNew: "Closing price",
    heightPrice: "24h Hight",
    lowPrice: "24h low",
    latestTransaction: "Latest transaction",
    FloatingPL: "Floating profit and loss",
    storageFee: "Storage fee",
    status1: "Automatic profit stop closing",
    status2: "Automatic stop loss closing",
    status3: "Manual closing",
    status4: "Manual stop loss closing",
    status5: "In operation",
  },


  assets: {
    accountOverview: "Account overview",
    currencyAccount: "Currency account",
    contractAccount: "Contract account",
    transfer: "Transfer",
    withdrawMoney: "Withdraw money",
    chargeMoney: "Charge money",
    Cryptocurrency: "Cryptocurrency",
    currency: "Currency",
    available: "Available",
    valuation: "Valuation",
    operation: "Operation",
    chargingCurrency: "Select charging currency",
    currencyType: "Currency",
    alert1: "Minimum recharge amount",
    alert2: "Recharge less than the minimum amount will not be credited and cannot be returned",
    ChargingInfo: "Confirm currency information",
    ChargingNetwork: "Charging network",
    rule2: "After you recharge to the above address, you need the confirmation of the whole network node. After 12 network confirmations, you can arrive, and after 12 network confirmations, you can withdraw money.",
    rule3_btc: "Minimum recharge amount: 0.01btc. Recharge less than the minimum amount will not be posted and cannot be returned.",
    rule3_usdt: "Minimum recharge amount: 300usdt. Recharge less than the minimum amount will not be posted and cannot be returned.",
    rule3_eth: "Minimum recharge amount: 0.15eth. Recharge less than the minimum amount will not be posted and cannot be returned。",
    rule4: "Your recharge address will not change frequently, and you can recharge repeatedly; If there is any change, we will try our best to inform you through website announcement or email.",
    rule5: "Please make sure that the computer and browser are secure to prevent information from being tampered with or disclosed",
    ChargingRecord: "Charging record",
    time: "Time",
    netWorkAddress: "Website address",
    selectWithdrawalCurrency: "Select the currency of withdrawal",
    ol1: "In order to ensure the safety of funds, when your account security policy is changed or your password is changed, we will manually review the withdrawal. Please be patient and wait for the staff to contact you by email.",
    ol2: "Please make sure that the computer and browser are secure to prevent information from being tampered with or disclosed",
    withdrawalInfo: "Fill in the withdrawal information",
    withdrawAddress: "Withdrawal address",
    withdrawalNetwork: "Withdrawal network",
    withdrawalNum: "Number of withdrawals",
    minWithdrawalNum: "Minimum withdrawal amount",
    actualArrival: "Actually arrived",
    notLessThan: "Not less than",
    viewAll: "View all currencies",
    withdrawalRecord: "Withdrawal record",
    transferCurrency: "Please select the transfer currency",
    transferNum: "Number of transfers",
    from: "From",
    to: "Arrive",
    transferRecord: "Transfer record",
    exceedBalance: "Cannot be greater than the available quantity",
    use: "Use",
    convertInto: "Convert to",
    exchangeRate: "Exchange rate",
    exChangeAlert: "Rate: 2% | Absenteeism payable",
    exchangeInstructions: "Exchange instructions",
    desc1: "Please note that the price of capital exchange will change at any time due to the depth of the market and the market situation. Please refer to the final amount after the order is confirmed",
    desc2: "According to the requirements of the risk control system, if the fund exchange triggers the third-party risk control, the exchange user needs to cooperate with the auditor to improve the relevant audit. If the audit cannot be improved, the order will be refunded for you for at least one month (30 days)",
    desc3: "Please ensure that the exchange of funds is a personal act, and confirm that you do not use digital currency to participate in any illegal activities such as MLM, illegal fund-raising and fraud. Please be vigilant against all illegal projects that promise high interest reporting, and beware of being cheated to avoid unnecessary losses",
    exchangeRecord: "Exchange record",
    useCurrency: "Use currency",
    exchangeCurrency: "Exchange currency",
    AbsenteeismFee: "Absenteeism fee",
    exchangeQuantity: "Exchange quantity",
    paymentPassword: "Please enter the payment password",
    currencyNoSame: "Currency cannot be the same"
  },

  // 二期
  iteration: {
    contractMarket: "Contract market",
    quotationDesc: "Digital currency market",
    accountOverview: "Account Preview",
    accountOverviewDesc: "Account Fund Preview",
    all: "Whole",
    userCenter: "Personal Center",
    viewInfo: "View personal information",
    setPsdDesc: "Setting strong password good for security",
    homeTitle: "Top 1 Altcoin Exchange",
    homeDesc: "Discover promising coins that cannot be found on other exchanges.",
    homeTitle2: "Largest Social Trading Platform",
    homeDesc2: "Interact with global crypto investors and gain access to timely and trusted crypto news.",
    homeTitle3: "The People's Exchange",
    homeDesc3: "The platform was designed for investors of all types, with 24/7 world-class services in your preferred channel and language.",
    homeTitle4: "Trade Anytime, Anywhere",
    homeDesc4: "The app and website allow you to start trading with ease.",
    homeTitle5: "What is Bitcoin?",
    homeDesc5: "Bitcoin is a decentralized digital currency, meaning that it lacks a central bank or single administrator. Bitcoin can be sent from user to user through the peer-to-peer network without the need for intermediaries.",
    homeTitle6: "Can I start trading with just $1?",
    homeDesc6: "Users to improve their practical experience through a variety of trading and financial products for as low as $1.",
    homeTitle7: "Is BitFuy safe?",
    homeDesc7: "BitFuy boasts one of the world's most sophisticated security technology and maintenance team, and is constantly upgrading our security systems to ensure the safety of user assets and accounts.",
    homeTitle8: "Is there an exchange limit between fiat and crypto?",
    homeDesc8: "BitFuy has no restrictions on the exchange between fiat and crypto.",
    homeTitle9: "Start Your Crypto Journey Now!",
    homeDesc9: "With the BitFuy app and website, trading has never been easier.",
    digitalCurrency: "Digital currency",
    qualityInformation: "High quality consulting",
    globalInvestor: "Global investor",
    internationalCommunity: "International community",
    countriesCovered: "Countries covered",
    transactionText: "Buy coins with a credit card, bank transfer, Apple Pay, or other options",
    cumulative: "Cumulative",
    realTimeTransaction: 'Real time transaction',
    balance: "balance",
    totalMargin: "Total margin",
    transferQuantityTips: "Transfer quantity must be greater than 0",
    notCertified: "Not certified",
    certified: "Certified",
    underCertification: "Under certification",
    digitalCurrencyTransactions: "Digital currency transactions",
    setCapitalPsw: "Set fund password",
    authenticationTips: "Please conduct primary certification",
    than: "The value must be greater than 0"
  }
}